export { DwSsoLoginModule } from './sso-login.module';
export { DwSsoService } from './service/sso.service';

export * from './sso-login.component';
export * from './sso-button/sso-button.component';
